import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, MessageCircleHeart } from 'lucide-react';

export default function ArtikelEidGruesseWuensche() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Mubarak Grüße und Wünsche: Die schönsten Formulierungen</h1>
          <p className="text-lg text-white/80 leading-relaxed">Herzliche Eid-Grüße für WhatsApp, Karten und persönliche Nachrichten – auf Deutsch, Arabisch und Türkisch.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Ob per WhatsApp, auf einer Karte oder persönlich – die richtigen Worte zu Eid machen das Fest noch schöner. Hier findest du eine Sammlung der herzlichsten Eid-Grüße und -Wünsche in verschiedenen Sprachen und für verschiedene Anlässe.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><MessageCircleHeart className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Klassische Eid-Grüße</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Arabisch</h4>
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li><strong>"Eid Mubarak"</strong> – Gesegnetes Fest (der Klassiker)</li>
                  <li><strong>"Eid Sa'eed"</strong> – Frohes Fest</li>
                  <li><strong>"Taqabbal Allahu minna wa minkum"</strong> – Möge Allah es von uns und von euch annehmen</li>
                  <li><strong>"Kull 'am wa antum bikhayr"</strong> – Möget ihr jedes Jahr bei guter Gesundheit sein</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Türkisch</h4>
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li><strong>"Bayramınız mübarek olsun"</strong> – Möge euer Fest gesegnet sein</li>
                  <li><strong>"Bayramınız kutlu olsun"</strong> – Frohes Fest</li>
                  <li><strong>"Hayırlı bayramlar"</strong> – Gesegnete Feiertage</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Deutsch</h4>
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li><strong>"Frohes Eid!"</strong> – Kurz und herzlich</li>
                  <li><strong>"Eid Mubarak! Ich wünsche dir und deiner Familie ein gesegnetes Fest."</strong></li>
                  <li><strong>"Zum Eid-Fest die allerbesten Wünsche für dich und deine Liebsten."</strong></li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Herzliche Grüße für Familie</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für die Eltern</h4>
                <p className="text-sm text-[#4B5563] italic">"Liebe Mama, lieber Papa – Eid Mubarak! Danke, dass ihr mir die Schönheit unseres Glaubens gezeigt habt. Möge Allah euch mit Gesundheit, Glück und Barakah segnen. Ich bin so dankbar für euch."</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Geschwister</h4>
                <p className="text-sm text-[#4B5563] italic">"Eid Mubarak, mein/e Liebe/r! Ich bin so froh, dass wir gemeinsam feiern können. Möge dieses Eid voller Lachen, gutem Essen und noch besserer Gesellschaft sein. Hab dich lieb!"</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Großeltern</h4>
                <p className="text-sm text-[#4B5563] italic">"Eid Mubarak, liebe Oma/lieber Opa! Eure Geschichten, eure Liebe und euer Dua sind das wertvollste Geschenk. Möge Allah euch ein langes, gesegnetes Leben schenken."</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Kinder</h4>
                <p className="text-sm text-[#4B5563] italic">"Eid Mubarak, mein Schatz! Du bist das größte Geschenk. Möge Allah dich immer beschützen und dein Herz mit Freude füllen. Jetzt gibt's Geschenke!"</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Grüße für Freunde & Kollegen</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für muslimische Freunde</h4>
                <p className="text-sm text-[#4B5563] italic">"Eid Mubarak, Habibti/Habibi! Nach einem gesegneten Ramadan feiern wir jetzt richtig! Möge dieses Eid dir alles bringen, was dein Herz sich wünscht."</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für nicht-muslimische Freunde (die gratulieren möchten)</h4>
                <p className="text-sm text-[#4B5563] italic">"Happy Eid! Ich wünsche dir und deiner Familie ein wunderschönes Fest voller Freude und gutem Essen. Genieße den Tag!"</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Kollegen</h4>
                <p className="text-sm text-[#4B5563] italic">"Eid Mubarak! Ich wünsche dir und deiner Familie ein frohes und gesegnetes Fest. Genieße die freien Tage!"</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Grüße für Eid-Karten</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Kurz & Elegant</h4>
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>"Eid Mubarak. Möge dieses Fest Freude und Segen in euer Zuhause bringen."</li>
                  <li>"Mit herzlichen Grüßen zum Eid-Fest. Möge Allah all eure Gebete erhören."</li>
                  <li>"Eid Mubarak! Feiert schön und genießt die Zeit mit euren Liebsten."</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Poetisch</h4>
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>"Wie der Mond den Ramadan beendet, so möge ein neues Kapitel voller Segen beginnen. Eid Mubarak."</li>
                  <li>"Möge das Licht des Eid euren Weg erhellen und eure Herzen mit Frieden füllen."</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">WhatsApp-Status & Social Media</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li>"Eid Mubarak an alle, die gefastet, gebetet und durchgehalten haben. Ihr habt es verdient!"</li>
                <li>"Ramadan ist vorbei, aber die Barakah bleibt. Eid Mubarak!"</li>
                <li>"Feiert, lacht, esst und seid dankbar. Eid Mubarak!"</li>
                <li>"Familie + gutes Essen + Eid = Perfekter Tag"</li>
                <li>"Taqabbal Allahu minna wa minkum. Möge Allah es von uns und euch annehmen."</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tipps für die perfekte Eid-Karte</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Persönlich schreiben:</strong> Ein handgeschriebener Gruß ist mehr wert als jede gedruckte Karte</li>
                <li><strong>Dua hinzufügen:</strong> Ein persönliches Bittgebet macht den Gruß spirituell</li>
                <li><strong>Kinder einbeziehen:</strong> Lass Kinder ihre eigenen Karten malen und gestalten</li>
                <li><strong>Eidi-Umschlag:</strong> Kombiniere die Karte mit einem kleinen Geldgeschenk</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Die schönsten Grüße kommen von Herzen. Ob ein einfaches "Eid Mubarak" oder eine lange, persönliche Nachricht – was zählt, ist die Aufrichtigkeit dahinter. Nimm dir die Zeit, deine Liebsten zu grüßen und ihnen zu zeigen, dass du an sie denkst.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak!</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/was-ist-eid" className="text-[#4A5D4F] hover:underline">→ Was ist Eid? Ein Leitfaden</Link></li>
              <li><Link to="/ratgeber/personalisierte-geschenke-eid" className="text-[#4A5D4F] hover:underline">→ Personalisierte Geschenke zu Eid</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
